<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-content-box">
        <div class="login-content-box-left">{{ $t('loginTitle') }}</div>
        <a-card class="login-panel">
          <div class="login-panel-title">{{ $t('cargoLogin') }}</div>
          <a-form-model class="login-form" :model="loginInfo" :rules="validateRules" ref="loginForm">
            <a-form-model-item class="login-from-item" prop="username">
              <a-input class="login-from-input" v-model.trim="loginInfo.username" size="large" :placeholder="$t('pleaseEnterEmailAddress')">
                <a-icon style="color: #1F6CBA" slot="prefix" type="user"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item class="login-from-item" prop="password">
              <a-input class="login-from-input" v-model.trim="loginInfo.password" size="large" type="password" :placeholder="$t('pleaseEnterYourPassword')"
                       @keyup.enter.native="login">
                <a-icon style="color: #1F6CBA" slot="prefix" type="lock"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item class="login-from-item">
              <a-button type="primary" :loading="loading" size="large" @click="login" block>
                {{ $t('login') }}
              </a-button>

              <div style="text-align: center;margin-top: 10px;">
                <a-button @click="skipContainer" style=" background:#FFFFFF;border:1px solid #1F6CBA; color: #1F6CBA" type="dashed">{{$t('switchContainer')}}</a-button>
              </div>
            </a-form-model-item>
            <a-form-model-item class="login-from-item">
              <a-checkbox class="login-form-checkbox" v-model.trim="flag"><a @click="hintShow = true" style="color: #999999">{{ $t('loginAgreementTitle') }}</a></a-checkbox>
            </a-form-model-item>
          </a-form-model>
          <div class="login-panel-bottom">
            <div>{{ $t('noAccountYet') }}?<a style="color: #1F6CBA" @click="$router.push('/register')">{{ $t('creatingPlatformAccount') }}</a></div>
            <a style="color: #1F6CBA" @click="$router.push('retrievePassword')">{{ $t('forgetPassword') }}</a>
          </div>
        </a-card>
      </div>
    </div>
    <div class="login-footer">
      <img class="login-footer-qc-img"  src="../../../public/static/index/weChat.jpg" />
      <div class="login-footer-qc-title">{{ $t('logoTitle') }}</div>
      <div class="login-footer-bottom-title">
        <span style="margin-right: 24px">{{ $t('indexFooterAddress') }}</span>
        <span>Copyright  {{ $moment().format('YYYY') }} </span>
        <a href="https://beian.miit.gov.cn/" target="_blank">{{ $t('copyright') }}</a>
      </div>
    </div>
    <a-modal v-model.trim="hintShow" :title="$t('privacyTitle')" width="60%">
      <pre style="height: 400px;overflow-y: auto;white-space: normal;">
        {{$t('privacyPolicy')}}
      </pre>
    </a-modal>
  </div>
</template>

<script>
import loginHeader from "../../components/common/login-header";
export default {
  name: 'login',
  components: {loginHeader},
  data() {
    return {
      loginInfo: {
        username: '',
        password: '',
      },
      validateRules: {
        username: [{ required: true, message: this.$t('pleaseEnterEmailAddress'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('pleaseFillInThePassword'), trigger: 'blur' }],
      },
      loading: false,
      flag:true,
      hintShow: false
    };
  },
  methods: {
    skipContainer(){
      window.open(`/container-container/login`,"_blank")
    },
    login() {
      this.$refs.loginForm.validate((val) =>{
        if(val){
          this.loading = true;
          this.$store.dispatch('login', this.loginInfo).then(data => {
            this.$router.replace('/index');
          }).catch(e =>{
            this.$message.info(this.$t(e.status))
          }).finally(() => {
            this.loading = false;
          });
        }
      })
    },
  },
  created() {
  }
};
</script>

<style lang="scss">
.login-page {
  .ant-checkbox-wrapper {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    display: inline-block;
    line-height: normal;
    cursor: pointer;
  }
  .login-content{
    height: 500px;
    background-image: url("../../../public/static/login/bg1.png");
    background-size: 100% 100%;
    .login-content-box{
      width: 990px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      align-items: center;
      .login-content-box-left{
        font-size: 36px;
        flex: 1;
        color: #FFFFFF;
      }
      .login-panel {
        width: 350px;
        background: #FFFFFF;
        border-radius: 4px;
        justify-content: center;
        .login-panel-title{
          display: flex;
          justify-content: center;
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 28px;
        }
        .login-form{
          .login-from-item{

            button{
              background: #1F6CBA;
              border: 0;
            }

            .login-from-input{
              font-size:14px
            }

            .login-form-checkbox{
              font-size: 12px;color: #999999;
            }
          }
        }
        .login-panel-bottom{
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  .ant-form-item {
    box-sizing: border-box;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    margin-bottom: 10px;
    vertical-align: top;
  }

  .login-footer {
    margin-top: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .login-footer-qc-img{
      width: 114px;height: 114px
    }
    .login-footer-qc-title{
      color: #1F6CBA;
      margin-top: 8px;
    }
    .login-footer-bottom-title{
      margin-top: 22px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

}
</style>
